import React from 'react';

const ConsentSuccessPage = () => {
  const handleClose = () => {
    window.close();
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          padding: '48px',
          maxWidth: '480px',
        }}
      >
        <h1
          style={{
            fontSize: '24px',
            fontWeight: '600',
            color: '#1a1a1a',
            margin: '0 0 16px',
          }}
        >
          Admin consent granted
        </h1>
        <p
          style={{
            fontSize: '16px',
            color: '#666666',
            margin: '0 0 24px',
          }}
        >
          Microsoft Graph admin consent has been granted successfully. You can close this tab.
        </p>
        <button
          type="button"
          onClick={handleClose}
          style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#1976d2',
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          Close this page
        </button>
      </div>
    </div>
  );
};

export default ConsentSuccessPage;
